import React from "react";
import PersonalDetails from "./PersonalDetails";
import CompanyDetails from "./CompanyDetails";

const PersonalInfoTab = ({ user }) => {
  return (
    <>
      <PersonalDetails user={user} />
      <CompanyDetails company={user.companyId} userEmail={user.email} />
    </>
  );
};

export default PersonalInfoTab;
